/**
 * @copyright       Palace Resorts
 * @description     Mensajes para 
 * @author          
 * @creationDate    
 */

import _ from "lodash";
import appMessages from "@/i18n/app.messages";

let moduleMessages = {
    messages: {
        ESP: {
            lblTitle: "Registro de Documentos",
            lblSubtitle: "Documentos",
            
        },
        ENG: {
            lblTitle: "Documents register",
            lblSubtitle: "Documents",
        },
    },
};

export default _.merge(moduleMessages, appMessages);